'use strict';

var ChartFBCUsageFilterFactory = function ChartFBCUsageFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FaresFilterByMarketFactory', 'FaresFilterByClassFactory', 'FaresFilterByMonthFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function ChartFBCUsageFilter() {
    DemandFilter.call(this, 'fares-chart-mode', 'fares-fbc-usage-chart');
    this.registerFilters(injectedFilters);
  }
  ChartFBCUsageFilter.prototype = Object.create(DemandFilter.prototype);
  ChartFBCUsageFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  return ChartFBCUsageFilter;
};
ChartFBCUsageFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = ChartFBCUsageFilterFactory;